import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { IIndustryMast } from "../../models/IndustryMast";
import { IModel } from "./IndustryMast";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import React from 'react';
import { EmptyIndustry } from "./EmptyIndustry";
import { IPermissionProps } from "../../models/Login";


interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IIndustryMast>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Industry_Mast", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IIndustryMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyIndustry });
    };


    const openEdit = (rowDatauser: IIndustryMast) => {

        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Industry Type </h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );



    const actionBodyTemplate = (rowData: IIndustryMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };


    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                ref={dt}
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >

                <Column field="industry_Name" header="Industry Type" />
                <Column field="description" header="Description" />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
